<template>
  <v-layout wrap class="mx-3">
    <v-flex xs12>
      <img src="@/assets/loader.png" style="width: 25px; height: 25px; margin-right: 5px;" v-if="loader==true" />
        <v-text-field
          v-model="location"
          label="Enter Location"
          @keyup.native="searchLocation"
          @focus="activateSearch"
          @blur="deactivate"
        ></v-text-field>
    </v-flex>

    <v-flex xs10
      class="search-drop search-drop-down pb pb-2"
      v-bind:class="{ searching: searching }"
    >
      <div class="pt-1 pb-2"></div>
      <div v-for="(item, index) in locations" :key="index">
        <span v-html="item.description" @click="fillLocation(item)"></span>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  computed: {
    searching() {
      if (this.location.trim() !== "" && !this.blured) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      loader: false,
      location: "",
      searchPhrase: "",
      active: false,
      locations: [],
      searchSuggestions: [],
      blured: true,
      session: "sdb3sdf3"
    };
  },
  methods: {
    clearLocation() {
      this.location = "";
    },
    fillLocation(place) {
      // get location
      const self = this;
      const data = {
        placeId: place.place_id
      };
      self.loader = true;
      const res = this.$store.dispatch("postapi", { url: "api/client/fetch/place", data }).then(res => {
          self.$emit("location", res.place.result.geometry.location);
          self.location = res.place.result.formatted_address;
          self.loader = false;
          }, error => {
            console.log(error);
      });
    },
    searchLocation() {
      this.location = event.target.value;
      const self = this;
      if (this.location === "") {
        self.$emit("location", null);
        this.session = Date.now();
        return;
      }
      const data = {
        keyword: this.location,
        sess: this.session
      };
      const res = this.$store.dispatch("postapi", { url: "api/client/location", data }).then(res => {
          const { predictions } = res.locations;
          this.locations = predictions;
        }, error => {
            console.log(error);
        });
      
    },
    fillInput(category) {
      this.searchPhrase = category;
      this.$emit("data", category);
    },
    deactivate() {
      setTimeout(() => {
        this.blured = true;
      }, 200);
    },
    activateSearch() {
      this.blured = false;
    }
  }
};
</script>

<style scoped>
.search-btn {
  background-color: #ff4500;
  border-radius: 0px;
  color: #fff;
}

.search-btn:hover {
  background-color: orange;
  border-radius: 0px;
  color: #fff;
}

.search-btn:focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-color: #cccccc;
}

.search-input-box:focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-color: #cccccc;
}
.search-drop-down {
  /* min-height: 40px; */
  /* transition: all 0.3s ease-in-out; */
  position: absolute;
  margin-top: 50px;
  z-index: 300;
}

/* drop down styles */
.search-drop {
  background: #fff;
  transition: all 0.3s ease-in-out;
  border-top: 1px solid #e3e3e3;
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.26s ease;
  box-shadow: 2px 2px 4px #bdbdbd;
  cursor: pointer;
}
.searching {
  min-height: 30px;
  /* transition: all 0.3s ease-in-out; */
  transform: scaleY(1);
}
.faint {
  color: #e0e0e0;
}
</style>